// Kept separate from the lazily loaded telemetry chunk so callers can import it cheaply
type UserContextSetter = (userId: string | undefined) => void;

let setter: UserContextSetter | undefined;
let pending: { userId: string | undefined } | undefined;

export function registerTelemetryUserSetter(fn: UserContextSetter): void {
  setter = fn;
  if (pending) {
    fn(pending.userId);
    pending = undefined;
  }
}

export function setTelemetryUser(userId: string | undefined): void {
  if (setter) {
    setter(userId);
  } else {
    pending = { userId };
  }
}
